import { useContext } from 'react'

import {
  Box, Button, Link, ModalContext, SidebarModal, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import EntitySelector from '@components/EntitySelector'

import useBrand from '@hooks/useBrand'

import useManageBrandTemplateDevelopersModal from './hooks/useManageBrandTemplateDevelopersModal'

const MODAL_KEY = 'ManageBrandTemplateDevelopersModal'

export type ModalCallbacks = {
  closeModal: () => void,
  updateBrand: (payload: HandleCallbackActionParams) => Promise<object>,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  modalKey?: string,
  showModal: boolean,
}

const ManageBrandTemplateDevelopersModal = (props: ModalProps) => {
  const { callbacks: modalCallbacks, modalKey, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { brand: initBrand } = modalPayload

  const {
    brand,
    callbacks: {
      updateBrand: updateFn,
    },
    templateDeveloperUserIds,
    updating,
  } = useBrand(initBrand)

  const {
    callbacks: {
      assignTemplateDeveloper,
      manageUserTeamMemberRoles,
      setState,
    },
    isUserTemplateDeveloper,
    selectedUserId,
  } = useManageBrandTemplateDevelopersModal(brand)

  return (
    // @ts-expect-error TS2322
    <SidebarModal callbacks={modalCallbacks} modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={modalCallbacks}
        title="Assign"
        titleSecondLine="Template Developer"
      />

      <SidebarModal.Content>
        <Box flexDirection="column">
          <EntitySelector
            callbacks={{
              // @ts-expect-error TS2322
              selectItem: user => setState({ selectedUserId: user?.id }),
            }}
            entityKey="users"
            entityTitleKey="full_name"
            label="* Template Developer"
            searchRequestOptions={{ admin_users_only: true }}
            selectedIds={[...templateDeveloperUserIds, selectedUserId]}
            // @ts-expect-error TS2322
            selectedItemId={selectedUserId}
          />

          {selectedUserId && !isUserTemplateDeveloper && (
            <SidebarNoticeBox boxProps={{ marginTop: 'large' }}>
              <SidebarNoticeBox.Title>
                Selected User is not a Template Developer.
              </SidebarNoticeBox.Title>

              <SidebarNoticeBox.Paragraph>
                <Link onClick={() => manageUserTeamMemberRoles()}>
                  Update User Roles
                </Link>
              </SidebarNoticeBox.Paragraph>
            </SidebarNoticeBox>
          )}
        </Box>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!isUserTemplateDeveloper}
          loading={updating}
          // @ts-expect-error TS2322
          onClick={() => assignTemplateDeveloper({ ...modalCallbacks, updateFn })}
          size="large"
        >
          {isUserTemplateDeveloper ? 'Assign Template Developer' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageBrandTemplateDevelopersModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
